import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BreadcrumbItem } from '../../../domain/src/lib/breadcrumb.model';

export interface MenuItemData {
  label: string;
  route?: string;
  icon?: string;
  url?: string;
}

export type BreadcrumbModule =
  | 'accounting'
  | 'treasury'
  | 'budget'
  | 'vault'
  | 'invoicing'
  | 'maestros'
  | 'products'
  | 'company';

@Injectable({ providedIn: 'root' })
export class BreadcrumbSyncService {
  private breadcrumbSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
  readonly breadcrumb$: Observable<BreadcrumbItem[]> = this.breadcrumbSubject.asObservable();

  private currentItems: BreadcrumbItem[] = [];

  update(items: BreadcrumbItem[]): void {
    this.currentItems = items;
    this.breadcrumbSubject.next([...items]);
  }

  getCurrent(): BreadcrumbItem[] {
    return [...this.currentItems];
  }

  clear(): void {
    this.currentItems = [];
    this.breadcrumbSubject.next([]);
  }
}
